/**
 * Defensive title-case for player/coach first names. Some sources store
 * `displayName` lowercase (e.g., the seeded test player has `displayName: "player"`),
 * so any time we interpolate a first name into user-facing copy we run it
 * through this helper so it always renders title-cased.
 *
 * Returns `'player'` as a final fallback when the input is null/undefined
 * or whitespace-only, so callers can interpolate without first-guarding.
 *
 * Shared by ProgressReportModal, ProgressReportViewerModal, the new
 * progress-report MessageBubble subtitle, and the CoachBundleProgress
 * success toast. Centralized here so the behaviour stays consistent
 * across surfaces.
 */
export function capName(n?: string): string {
  if (!n) return 'player';
  const trimmed = n.trim();
  if (trimmed.length === 0) return 'player';
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
